export function isValidQuery(query, searchOptions, searchOptionsFiles, isAllFiles) {
    if (isAllFiles) {
        return query.q && query.q.trim() && query.area && searchOptionsFiles.map(option => option.name).includes(query.area.trim());
    } else {
        return query.q && query.q.trim() && query.area && searchOptions.map(option => option.name).includes(query.area.trim());
    }
};

export function isValidSearchQuery(query, searchOptions) {
    return query.query && query.query.trim() && query.area && searchOptions.map(option => option.name).includes(query.area.trim());
};



// WEBPACK FOOTER //
// ./src/scripts/ResultsQueryValidation.js